"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var StyleLibrary_1 = __importDefault(require("DreamCoat/SavedStyle/StyleLibrary/StyleLibrary"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var MaybeSavedBlockProvider_1 = require("Project/BlockNew/SavedBlocks/MaybeSavedBlockProvider");
var Configuration_1 = require("Styles/Configuration/Configuration");
module.exports = function (mountReactComponent, styleModalService, savedStyleService, blockStore, telemetry, stylePermissionStore, brandStore) {
    var props = {
        blockStore: blockStore,
        savedStyleService: savedStyleService,
        styleModalService: styleModalService,
        telemetry: telemetry,
        stylePermissionStore: stylePermissionStore,
        brandStore: brandStore,
    };
    return mountReactComponent(react_1.default.createElement(MaybeSavedBlockProvider_1.MaybeSavedBlockProvider, { blockStore: blockStore },
        react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.angularTooltipZIndex }, function () { return react_1.default.createElement(StyleLibrary_1.default, __assign({}, props)); })));
};
